import { createContext } from "react";
import type { IntlShape } from "react-intl";

export interface PersonChoice {
  id: string;
  name: string;
  // What the reply called the person: the choice is remembered under this name.
  asked: string;
  // Role and city, when known: what tells two people of the same name apart in the answer sent back.
  detail?: string | null;
}

/**
 * What choosing a person among a reply's candidates does where the reply is shown: the drawer and the Studio
 * notebook each send it back as the user's answer in their own conversation. No provider, no choice offered.
 */
export const PersonChoiceContext = createContext<((choice: PersonChoice) => void) | null>(null);

/** The answer a choice sends: the person's name, with role and city when known, so the model tells two people of one name apart. */
export function personChosenMessage(intl: IntlShape, choice: PersonChoice): string {
  return intl.formatMessage(
    { id: "agent.personChosen", defaultMessage: "I mean {person}, the person in the system." },
    { person: choice.detail ? `${choice.name} (${choice.detail})` : choice.name },
  );
}
